import script from "./UploadRevenueProjection.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadRevenueProjection.vue?vue&type=script&setup=true&lang=js"

import "./UploadRevenueProjection.vue?vue&type=style&index=0&id=7d813f5d&lang=css"

const __exports__ = script;

export default __exports__